import { helper as buildHelper } from '@ember/component/helper';

export function messageCenterUserCanManageThread(params/*, hash*/) {
  let user = params[0],
    thread = params[1],
    threadUsers = thread.get('etc.relationships.users'),
    isInThread = false;

  threadUsers.forEach((threadUser) => {
    let role = threadUser.role;

    if (user.get('id').toString() === threadUser.user_id.toString() &&
    (role === 'buyer' || role === 'watcher')) {
      //any watcher or buyer on a thread can manage it
      isInThread = true;
    }
  });

  ///use
  return user.get('isBuyer') && isInThread;
}

export default buildHelper(messageCenterUserCanManageThread);
